import React from "react";
import { Modal } from "react-bootstrap";

const GeneralInfoModal = ({ show, handleClose }) => {
  return (
    <Modal show={show} onHide={handleClose} size="lg">
      <Modal.Header closeButton>
        <Modal.Title>General Instructions</Modal.Title>
      </Modal.Header>
      <Modal.Body style={{ maxHeight: "70vh", overflowY: "auto" }}>
        <h5>A1. GENERAL INSTRUCTION FOR COMPLETING THE ARBITRATION FORM:</h5>
        <ul className="list-unstyled">
          <li className="mb-3">
            <strong>• Completeness:</strong> In order to facilitate a thorough and precise completion of the AECCI-IAC Arbitration submission
            form, the IAC administrator will actively engage with the party/parties, seeking their input and clarification on
            specific details. The parties can complete the form Starting from Section A to K and rest Office use section
            will be filled by AECCI-IAC Administrator. This collaborative approach aims to ensure that all necessary
            information is accurately captured and that the form aligns with the party'S intentions and requirements. The IAC
            administrator will provide guidance and assistance throughout the process to enhance clarity and understanding
            and the submission form will be completed by the IAC administrator in the presence of the party/parties
          </li>
          <li className="mb-3">
            <strong>• Accuracy:</strong> Double-check all the information provided in the form for accuracy and correctness. Any errors or
            inaccuracies may cause delays or complications in the arbitration process.
          </li>
          <li className="mb-3">
            <strong>• Supporting Documents:</strong> Attach all relevant supporting documents to the filing form. This may include the
            statement of daim. any contracts or agreements related to the dispute, correspondence or communication
            related to the dispute. and any other relevant evidence or documentation.
          </li>
          <li className="mb-3">
            <strong>• Format and Organization:</strong> Present the information in a dear and organized manner. Use appropriate headings.
            sections, and numbering to make it easy for the recipients to understand and navigate through the form.
          </li>
          <li className="mb-3">
            <strong>• Signatures:</strong> Ensure that all required signatures are provided where necessary. This may include the signatures of
            the parties involved in the dispute, authorized Counsels, or any other required signatories.
          </li>
          <li className="mb-3">
            <strong>• Filing Fee:</strong> Include the required filing fee along with the filing form, as specified by the AECCI-IAC. Ensure that the
            payment is made in the prescribed manner and includes any necessary supporting documentation or proof Of
            payment.
          </li>
          <li className="mb-3">
            <strong>• Timeliness:</strong> Submit the arbitration case filing forrn within the specified timeframe or deadline provided by the
            arbitration center or institution. Late submissions may result in the rejection or delay of the case filing.
          </li>
          <li className="mb-3">
            <strong>• Review and Confirmation:</strong> Before submitting the form, review all the information provided to ensure its
            accuracy and completeness. Confirm that all required documents are attached. fees are paid, and signatures are
            obtained as necessary.
          </li>
          <li className="mb-3">
            <strong>• Retain Copies:</strong> Make copies of the completed arbitration case filing form and all attached documents for your
            records. This will help in case of any future reference or need for additional copies.
          </li>
          <li className="mb-3">
            <strong>• Follow-up:</strong> After submitting the form, follow up with the arbitration center or institution to ensure that the case
            filing has been received and acknowledged. Maintain open communication with the center throughout the
            arbitration process.
          </li>
        </ul>
        <p className="mt-4">
          Please note that these instructions are general in nature. and specific requirements may vary depending on
          the AECCI- International Arbitration center or institution involved. It is advisable to refer to the specific
          guidelines and instructions provided by the center for a comprehensive understanding Of the case filing
          process.
        </p>
      </Modal.Body>
    </Modal>
  );
};

export default GeneralInfoModal; 